import React from 'react';
import AppListToolbarGlobal, { type CompanyOption } from '@/__core/components/AppLisstToolbarGlobal';
import {
  IconButton,
  Tooltip,
} from '@mui/material';

import { sharedToolbarListStyles } from '@/__core/styles';

export interface StockTransactionsToolbarGlobalProps {
  /** @deprecated Chỉ dùng khi test; mặc định lấy từ auth + resolveModuleAccessibleCompanies */
  companies?: CompanyOption[];
  fetchCompanies?: () => Promise<CompanyOption[]>;
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
  onSearchSubmit?: () => void;
  onToggleAdvancedSearch?: () => void;
  isAdvancedSearchOpen?: boolean;
  onFilterChange?: (field: string, value: string) => void;

  filters?: {
    company: string;
    stockState: string;
  };
  stockStateOptions?: Array<{ id: string; name: string }>;
  onRefresh?: () => void;
}

export default function StockTransactionsToolbarGlobal({
  companies,
  searchQuery = '',
  onSearchChange,
  onSearchSubmit,
  onToggleAdvancedSearch,
  isAdvancedSearchOpen = false,
  filters = { company: 'all', stockState: 'all' },
  onFilterChange,
  stockStateOptions = [],
  onRefresh,
}: StockTransactionsToolbarGlobalProps) {
  const stockStateFilterOptions = React.useMemo(
    () => stockStateOptions.map((option) => ({ value: option.id, label: option.name })),
    [stockStateOptions]
  );

  const advancedFilterFields = React.useMemo(
    () => [
      {
        key: 'stockState',
        label: 'Loại GD',
        labelWidth: 90,
        value: filters.stockState,
        placeholder: 'Chọn loại giao dịch',
        options: stockStateFilterOptions,
        onChange: (value: string) => onFilterChange?.('stockState', value),
        gridSize: { xs: 12, sm: 6, md: 6 },
      },
    ],
    [filters.stockState, onFilterChange, stockStateFilterOptions]
  );

  const rightActions = onRefresh ? (
    <Tooltip title='Làm mới' arrow>
      <IconButton
        onClick={onRefresh}
        size='small'
        sx={{
          ...sharedToolbarListStyles.actionIconButtonBase,
          backgroundColor: '#10b981',
          borderColor: '#10b981',
          color: 'white',
          '&:hover': { backgroundColor: '#059669', borderColor: '#059669' },
        }}
      >
      </IconButton>
    </Tooltip>
  ) : null;

  return (
    <AppListToolbarGlobal
      scopeModule='stocktransactions'
      companies={companies}
      searchPlaceholder='Tìm theo số tham chiếu, mã vật tư, kho, chứng từ...'
      searchQuery={searchQuery}
      onSearchChange={onSearchChange}
      onSearchSubmit={onSearchSubmit}
      isAdvancedSearchOpen={isAdvancedSearchOpen}
      onToggleAdvancedSearch={onToggleAdvancedSearch}
      selectedCompany={filters.company}
      onCompanyChange={(id) => onFilterChange?.('company', id)}
      advancedFilterFields={advancedFilterFields}
      rightActions={rightActions}
    />
  );
}
